const ossApi = '/ossApi'
let hostname = window.location.hostname
const encryptionJS = require('../../assets/js/encryption');
let areaCode = ''
let tenantCode = ''
let title = ''
let imageUrl = ''
let username = ''
let password = ''
let serviceUrl = ''  //履职服务平台
let systemType = ''
if (hostname === 'xxszx.gov.cn' || hostname === 'www.xxszx.gov.cn') {
  areaCode = '4107'
  tenantCode = '410700000000000001'
  title = '新乡市'
  imageUrl = ossApi + '/zx410700'
  serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
  systemType = 'cppcc'
  username = encryptionJS.aesDecrypt('jpJFpZSlYpBZB46kurHb7Q==')
  password = encryptionJS.aesDecrypt('X4aza5AzRKBgMEAuRpOwfw==')
}

switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    areaCode = '4107'
    tenantCode = '410700000000000001'
    title = '新乡市'
    imageUrl = ossApi + '/zx410700'
    serviceUrl = 'https://lzpt.hnzx.gov.cn/henan-platform/#/login'
    systemType = 'cppcc'
    username = encryptionJS.aesDecrypt('jpJFpZSlYpBZB46kurHb7Q==')
    password = encryptionJS.aesDecrypt('X4aza5AzRKBgMEAuRpOwfw==')
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  areaCode,
  serviceUrl,
  systemType
}
